// packages/shared-hooks/src/clients/usePatchLegalEntityRequisites.ts
//
// `PATCH /clients/:id/legal-entities/:leId/requisites/:requisitesId` — edits
// ONE bank set addressed by its own id, so editing a set never rewrites its
// siblings. An archived set is refused server-side with 409 DOMAIN_CONFLICT
// `meta.kind: 'requisites-archived'`.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  LegalEntityRequisitesSchema,
  type LegalEntityRequisites,
  type PatchLegalEntityRequisitesInput,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function usePatchLegalEntityRequisites(
  clientId: string,
  legalEntityId: string,
  requisitesId: string,
) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<LegalEntityRequisites, unknown, PatchLegalEntityRequisitesInput>({
    mutationFn: (input) =>
      client.patch<LegalEntityRequisites>(
        `/clients/${clientId}/legal-entities/${legalEntityId}/requisites/${requisitesId}`,
        input,
        {},
        LegalEntityRequisitesSchema,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: clientsKeys.detail(clientId) });
      void qc.invalidateQueries({ queryKey: clientsKeys.all });
    },
  });
}
